import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import CustomMenuItem from "../../../../../components/Menu/CustomMenuItem";
import { useStatusDropdown } from "./hooks/useStatusDropdown";

export default function StatusDropDown({ workflowId }) {
  const { workflow, workflowSteps, handleChange } = useStatusDropdown(workflowId);

  return (
    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
      <InputLabel id="demo-select-small-label">Status</InputLabel>
      <Select
        labelId="demo-select-small-label"
        id="demo-select-small"
        value={workflow}
        label="status"
        onChange={handleChange}
        className="board-header-status-dropdown"
      >
        <CustomMenuItem value="">
          <em>None</em>
        </CustomMenuItem>
        {workflowSteps.map((item) => (
          <CustomMenuItem key={`status-dropdown-${item?.workflow_step_id}`} value={item?.workflow_step_id}>{item?.status}</CustomMenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
